/** web-studio-sites D7: what coming up's current state requires a drawing to show: each booking's View, opening it. */
import type { RequiredParts } from '../../contract/required';
import type { ComingUpState } from './contract';

export const requiredParts: RequiredParts<ComingUpState> = (state) =>
  state.bookings.map((b) => ({ part: 'view', item: b.id, action: 'open' }));
